import React, {useEffect} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import {useMutation, useQuery} from "react-query";
import {getActivityDiscounts} from "../../Api/Query/ActivityQuery";
import {Enabled} from "../../Components/Enabled/Enabled";
import {Notificator} from "../../Services/Notificator/Notificator";
import SmallModal from "../../Components/Modal/SmallModal";
import {DiscountSingleSelect} from "../../Components/Discount/DiscountSingleSelect";
import {addActivityDiscount, deleteActivityDiscount} from "../../Api/Mutation/ActivityMutation";
import {useAppDispatch} from "../../hooks";
import {appLoading} from "../../Store/loadingSlice";
import {CourseLevelSelect} from "../../Components/CourseLevel/CourseLevelSelect";

interface Props {
    activityId?: string;
}

export const ActivityDiscountCrud: React.FC<Props> = (props) => {

    const dispatch = useAppDispatch()
    const [discounts, setDiscounts] = React.useState<any[]>([]);
    const [showAddDiscountModal, setShowAddDiscountModal] = React.useState<boolean>(false);

    const defaultAddDiscountData : any = {
        discount: null,
        courseLevel: null,
        initDate: null,
        endDate: null,
    }

    const [addDiscountData, setAddDiscountData] = React.useState<{
        discount: any,
        courseLevel: any,
        initDate: string|null,
        endDate: string|null,
    }>(defaultAddDiscountData);

    const discountsQuery = useQuery({
        enabled: false,
        queryKey: ['getActivityDiscounts', props.activityId ?? '-1'],
        queryFn: () => getActivityDiscounts(props.activityId ?? ''),
        onSuccess: (data: any) => {
            const response: any = data?.data?._result.items
            setDiscounts(response);
        }
    })

    const deleteDiscountMutation = useMutation({
        mutationKey: ['deleteActivityDiscount', props.activityId],
        mutationFn: (id: string) => deleteActivityDiscount(id),
        onSuccess: () => {
            Notificator.success('El descuento se ha eliminado correctamente');
            discountsQuery.refetch()
        },
        onError: () => {
            Notificator.error('Se ha producido un error al eliminar el descuento', 'Error');
        }
    })

    const addDiscountMutation = useMutation({
        mutationKey: ['addActivityDiscount'],
        mutationFn: (data: any) => addActivityDiscount(
            props.activityId ?? '-1',
            data.discount.value,
            data.courseLevel.value,
            data.initDate,
            data.endDate,
        ),
        onSuccess: () => {
            Notificator.success('El descuento se ha creado correctamente');

            discountsQuery.refetch()
            setShowAddDiscountModal(false)
            setAddDiscountData(defaultAddDiscountData)
        },
        onError: () => {
            Notificator.error('Se ha producido un error al crear el descuento', 'Error');
        }
    })

    const onAddDiscountClick = () => setShowAddDiscountModal(true)

    const deleteDiscount = (discountId: string) => {

        if (!window.confirm('¿Deseas eliminar este descuento?')) {
            return
        }

        deleteDiscountMutation.mutate(discountId)
    }

    const addDiscountToActivity = () => {
        if(!addDiscountData.discount && !addDiscountData.initDate && !addDiscountData.endDate) {
            Notificator.error('Rellena todos los campos', 'Error');
            return;
        }

        addDiscountMutation.mutate(addDiscountData)
    }

    useEffect(() => {
        if (props.activityId) {
            discountsQuery.refetch()
        }
    }, []);

    useEffect(() => {
        dispatch(
            appLoading({
                value: deleteDiscountMutation.isLoading,
                text: 'Cargando'
            })
        )
    }, [deleteDiscountMutation.isLoading])

    return (
        <>
            <Form.Group controlId={"sessions"}>
                <Row className={"d-flex"}>
                    <Col sm={12} md={6}>
                        <h3>Descuentos</h3>
                    </Col>
                    <Col sm={12} md={6} style={{"textAlign": "right"}}>
                        <Button
                            className={"purple-btn btn-sm float-right"}
                            onClick={onAddDiscountClick}
                        >
                            Añadir descuento
                        </Button>
                    </Col>
                </Row>

                <table className={"table table-bordered redTable"}>
                    <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Tipo</th>
                        <th>Valor</th>
                        <th>Curso</th>
                        <th>Fecha inicio</th>
                        <th>Fecha fin</th>
                        <th>Habilitado</th>
                        <th></th>
                    </tr>

                    {
                        discounts.length === 0 &&
                        <tr>
                            <td colSpan={7}>
                                Todavía no has añadido ningún descuento.
                            </td>
                        </tr>
                    }
                    {
                        discounts.map((item: any, key: number) => {
                            return (
                                <tr key={key}>
                                    <td>{item.discountName}</td>
                                    <td>{item.type}</td>
                                    <td>{item.value}</td>
                                    <td>{item.courseLevelName}</td>
                                    <td>{item.initDate}</td>
                                    <td>{item.endDate}</td>
                                    <td>
                                        <Enabled enabled={item.enabled}/>
                                    </td>
                                    <td>
                                        <Button
                                            className={"btn btn-danger btn-sm"}
                                            onClick={() => deleteDiscount(item.id)}
                                        >
                                            Eliminar
                                        </Button>
                                    </td>
                                </tr>
                            )
                        })
                    }

                    </thead>
                </table>

            </Form.Group>
            <SmallModal
                show={showAddDiscountModal}
                body={
                    <Col sm={12} md={6} className={"mx-auto my-4"}>
                        <h2 className={"mb-4"}>Añadir descuento</h2>
                        <Form>
                                <Form.Label>Descuento</Form.Label>
                                <DiscountSingleSelect
                                    onChange={(item: any) => {
                                        setAddDiscountData({
                                            ...addDiscountData,
                                            discount: item
                                        })
                                    }}
                                    value={addDiscountData.discount}
                                />

                                <br />
                                <Form.Label>Curso</Form.Label>
                                <CourseLevelSelect
                                    onChange={(item: any) => {
                                        setAddDiscountData({
                                            ...addDiscountData,
                                            courseLevel: item
                                        })
                                    }}
                                    value={addDiscountData.courseLevel}
                                />

                                <br />
                                <Form.Label>Fecha inicio</Form.Label>
                                <input
                                    type={"date"}
                                    className={"form-control"}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setAddDiscountData({
                                            ...addDiscountData,
                                            initDate: e.target.value
                                        })
                                    }}
                                />

                                <br />
                                <Form.Label>Fecha fin</Form.Label>
                                <input
                                    type={"date"}
                                    className={"form-control"}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setAddDiscountData({
                                            ...addDiscountData,
                                            endDate: e.target.value
                                        })
                                    }}
                                />
                        </Form>
                    </Col>
                }
                onClose={() => setShowAddDiscountModal(false)}
                onConfirm={addDiscountToActivity}
                isConfirmLoading={addDiscountMutation.isLoading}
            />
        </>
    )
}
